import { createSelector } from 'reselect';

const selectFundingReport = (state) => state.get('fundingReport');

const makeSelectFundingReportMatches = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['matches', 'data'], []));

const makeSelectFundingReportMatchesIsLoading = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['matches', 'network', 'loading']));

const makeSelectFundingReportMatchesError = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['matches', 'network', 'error']));

const makeSelectFundingReportMatchesSuccess = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['matches', 'network', 'success']));

export {
  makeSelectFundingReportMatches,
  makeSelectFundingReportMatchesError,
  makeSelectFundingReportMatchesIsLoading,
  makeSelectFundingReportMatchesSuccess,
};
